<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on" color="black">
        <v-icon>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">EDIT QAAS</v-card-title>
      <v-card-text>
        <v-form ref="EditeClientForm">
          <v-text-field
            outlined
            solo
            v-model.trim="CustomerInfo.FullName"
            validate-on-blur
            :rules="[v => !!v || 'First Name is required']"
            label="First Name"
            color="success"
            prepend-inner-icon="fas fa-user-edit"
            required
          >
          </v-text-field>

          <v-text-field
            outlined
            solo
            type="number"
            v-model.number="CustomerInfo.Qphone"
            validate-on-blur
            :rules="[v => !!v || 'Phone is required', minlength]"
            label="Phone"
            color="success"
            prepend-inner-icon="fas fa-mobile-alt"
            required
          >
          </v-text-field>

          <v-text-field
            outlined
            solo
            v-model.trim="CustomerInfo.IDNomber"
            validate-on-blur
            :rules="[v => !!v || 'Passport or other ID is required']"
            label="ID Number"
            color="success"
            prepend-inner-icon="fas fa-address-card"
            required
          >
          </v-text-field>
          <BaseNumInput
            outlined
            label="Limit Amount"
            v-model.number="CustomerInfo.limit"
          ></BaseNumInput>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" :disabled="clicked" text @click="close"
          >Cancel</v-btn
        >
        <v-btn
          color="green darken-1"
          :loading="clicked"
          text
          @click="OnEditeClient"
          >Save Edit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    ClientInfo: { type: Object, required: true },
    BaseURL: { type: String, required: true },
  },
  data() {
    return {
      clicked: false,
      dialog: false,
      ErrorMsg: "",
      CustomerInfo: {
        FullName: null,
        otherNames: null,
        Qphone: null,
        IDNomber: null,
        limit: 0,
      },
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.CustomerInfo.FullName = this.ClientInfo.FullName;
        // this.CustomerInfo.otherNames = this.ClientInfo.otherNames;
        this.CustomerInfo.Qphone = this.ClientInfo.Qphone;
        this.CustomerInfo.limit = this.ClientInfo.limit;
        this.CustomerInfo.IDNomber = this.ClientInfo.IDNomber;
        // this.ClientInfo.IDNomber = "12345";
      }
    },
  },
  methods: {
    OnEditeClient() {
      if (this.$refs.EditeClientForm.validate()) {
        this.clicked = true;
        this.CustomerInfo._id = this.ClientInfo._id;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: `${this.BaseURL}/Edit`,
            data: {
              ...this.CustomerInfo,
            },
          })
          .then(result => {
            this.clicked = false;
            // console.log(result);
            // console.log(this.ClientInfo);
            // this.ClientInfo = result.data;
            this.ClientInfo.FullName = result.data.FullName;
            // this.ClientInfo.otherNames = result.data.otherNames;
            this.ClientInfo.Qphone = result.data.Qphone;
            this.ClientInfo.IDNomber = result.data.IDNomber;
            this.ClientInfo.limit = result.data.limit;
            this.close();
          })
          .catch(() => {
            this.clicked = false;
            // console.log(error);
          });
      }
    },
    close() {
      this.dialog = false;
      this.$refs.EditeClientForm.resetValidation();
    },
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      // if (v && v.toString().length < 9)
      //   return "Phone length must be at least 9 number";
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    // save(date) {
    //   this.$refs.menu.save(date);
    // }
  },
  mounted() {
    // console.log(this.ClientInfo);
    this.CustomerInfo.firstName = this.ClientInfo.firstName;
    this.CustomerInfo.otherNames = this.ClientInfo.otherNames;
    this.CustomerInfo.Cusphone = this.ClientInfo.Cusphone;
    this.CustomerInfo.DOB = this.ClientInfo.DOB;
    this.CustomerInfo.IDNomber = this.ClientInfo.IDNomber;
    this.CustomerInfo.limit = this.ClientInfo.limit;
  },
};
</script>
